import React from 'react'
import LessonLinks from '../lesson-links'

export default function Lesson (props) {
  const {name, id, assigned} = props
  const assignedClass = (className) => assigned ? `${className} assigned` : className 
  return (
    <li className="lesson">
      <div className={assignedClass("item")}>
        <div className="bullet"></div>
        <div className="name">{`${id}: ${name}`}</div>
        <LessonLinks {...props} />
      </div>
    </li>
  )
}
